import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const EquipmentsInUseService = {
    apply: async (payload) => axios.post(`${API_URL}/equipments_in_use/apply`, payload).then(({data}) => data.data).catch((err) => { throw err })
};

export default EquipmentsInUseService;